import * as React from 'react';
import {Route, RouteComponentProps, Switch} from "react-router";
import {Link, NavLink} from "react-router-dom";
import {useTopicQuery} from "../../../../types.d";
import {TopicExplanations} from "./TopicExplanations";
import {TopicExercises} from "./TopicExercises";
import {EditTopicTab} from "./EditTopicTab";

export const TopicOverview = (props: RouteComponentProps<{ topic: string }>) => {
    const response = useTopicQuery({
        variables: {
            id: Number(props.match.params.topic)
        }
    });

    if (!response.data) {
        return <div className={'index-wrapper'}>
            <div className={'index-page'}>
                <h2>Loading...</h2>
            </div>
        </div>;
    }

    const { topic } = response.data;
    const { course } = topic.stage;

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to={`/courses/${course.sourceLanguage.id}`}>Course ({ course.sourceLanguage.name } -> { course.translationLanguage.name })</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        { topic.title } of Stage { topic.stage.level }
                    </li>
                </ol>
            </nav>

            <div className={'mb-4'}>
                <ul className={'nav nav-tabs'}>
                    <li className={'nav-item'}>
                        <NavLink className={'nav-link'} to={`${props.match.url}`} exact>Overview</NavLink>
                    </li>
                    <li className={'nav-item'}>
                        <NavLink className={'nav-link'} to={`${props.match.url}/explanations`} exact>Explanation cards</NavLink>
                    </li>
                    <li className={'nav-item'}>
                        <NavLink className={'nav-link'} to={`${props.match.url}/exercises`} exact>Exercise cards</NavLink>
                    </li>
                </ul>
            </div>

            <Switch>
                <Route path={`${props.match.path}/exercises`} component={TopicExercises} />
                <Route path={`${props.match.path}/explanations`} component={TopicExplanations} />
                <Route path={`${props.match.path}`} component={EditTopicTab} />
            </Switch>
        </div>
    </div>
};
